export default {
  archived(state, value) {
    state.archived = value;
  },
  currentPage(state, value) {
    return (state.currentPage = value);
  },
  paginationTotal(state, value) {
    return (state.total = value);
  },
  perPage(state, value) {
    return (state.perPage = value);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  tableLoading(state, value) {
    return (state.tableLoading = value);
  },
  allFeedbackSurvey(state, value) {
    state.allFeedbackSurvey = value;
  },
  setSelectedRow(state, value) {
    return (state.selectedRow = value);
  },
  setSurveyAnswers(state, value) {
    return (state.surveyAnswers = value);
  },
  resetState(state) {
    state.currentPage = 1;
    state.perPage = 5;
    state.searchQuery = "";
    state.total = 0;
    state.archived = false;
    state.allFeedbackSurvey = [];
  },
};
